'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bindings = require('./bindings');

var _subscribers = require('./subscribers');

var _handlers = require('./handlers');

var _handlers2 = _interopRequireDefault(_handlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './InlineCart';


exports.default = Object.assign({
  init: _handlers.init,
  initSubscribers: _subscribers.initSubscribers,
  bindActions: _bindings.bindActions
}, _handlers2.default);